<template>
	<div class="form-group">
		<label :for="getId" v-if="!!label">{{ label }}</label>
		<div class="form-wrap">
			<textarea
				:name="name"
				class="form-control"
				:class="{ 'is-invalid': !!error }"
				:id="getId"
				:placeholder="placeholder"
				:required="required"
				:disabled="disabled"
				:autofocus="autofocus"
				:readonly="readonly"
				v-model="internalValue"
			></textarea>
			<form-link-icon
				:value="internalValue"
				:customFormLink="customFormLink"
				:customFormText="customFormText"
				:customFormIcon="customFormIcon"
				v-if="!!showFormLink"
			></form-link-icon>
		</div>
		<small v-if="!!small" :id="getId + 'Help'" class="form-text text-muted">{{ small }}</small>
		<span class="invalid-feedback" role="alert" v-if="!!error">
			<strong>{{ error }}</strong>
		</span>
	</div>
</template>

<script>
export default {
	data: () => ({
		internalValue: '',
	}),
	props: {
		required: {
			type: Boolean,
			default: false,
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
		name: {
			type: String,
			default: '',
			required: false,
		},
		id: {
			type: String,
			default: '',
			required: false,
		},
		label: {
			type: String,
			default: '',
			required: false,
		},
		placeholder: {
			type: String,
			default: '',
			required: false,
		},
		small: {
			type: String,
			default: '',
			required: false,
		},
		value: {
			type: String,
			default: '',
			required: false,
		},
		autofocus: {
			type: Boolean,
			default: false,
			required: false,
		},
		error: {
			type: String,
			default: '',
			required: false,
		},
		readonly: {
			type: Boolean,
			default: false,
			required: false,
		},
		showFormLink: {
			type: Boolean,
			default: true,
			required: false,
		},
		customFormLink: {
			type: String,
			default: null,
			required: false,
		},
		customFormText: {
			type: String,
			default: null,
			required: false,
		},
		customFormIcon: {
			type: Array,
			default: () => [],
			required: false,
		},
	},
	created: function() {
		this.internalValue = this.value
	},
	computed: {
		getId: function() {
			return !!this.id ? this.id : !!this.name ? this.name : ''
		},
	},
}
</script>
